export default __webpack_public_path__ + "static/media/RWA.f0c1280d.svg";